export default __webpack_public_path__ + "static/media/IBimagefootplantfromabove1.ede942c0.png";